import React, { useEffect, useState } from "react";
import { errorToast } from "../../helpers/Notification";
import { getError } from "../../store/helpers/common_functions";
import ActivityDetails from "components/Activity/ActivityDetails";


const ProjectDndProvider = ({
    GetProject,
    project,
    activity,
    onSuccess,
    PutAction,
    DeleteTask,
    isInitiator,
    deliverable,
    deliverables,
    tasksOfDelivery,
    assignees,
    partners,
    canEdit = false,
    FetchDetails
}) => {

    const [realProject, setRealProject] = useState();
    const [realTasks, setRealTasks] = useState([]);

    const tasks = tasksOfDelivery ?? project?.Tasks;
    

    useEffect(() => {
        setRealProject(project)
    }, [project]);
    useEffect(
        () => setRealTasks(tasks),
        [tasks]
    );

    const fecthActivity = async () =>{

        const task =  await FetchDetails(`/api/activity/details/${activity?.id}`);

            if(task.status){
            setRealTasks(task?.data?.data?.tasks);
        }
        onSuccess();
        
    }


    const customDeleteTask = (deleteId) => {
        if (realProject) {
            realProject.Tasks.forEach((v) => {
                if (v.id === deleteId) {
                    v.loading = true;
                }
            });
            setRealProject({ ...realProject });
        }
        return DeleteTask(deleteId);
    }


    const onTaskChange = async (info) => {
        if (realProject) {
            let inApproved = false;
            tasks.forEach((v) => {
                if (v.id === info.id) {

                    // if(v.status === 'completed'){
                    //     inApproved = true;
                    //     errorToast("Completed task cannot be moved back");
                    // }else {
                    v.status = info.status ?? v.status;
                    v.name = info.name ?? v.name;
                    v.description = info.description ?? v.description;
                    v.loading = true;
                    // }
                }
            });

            if (inApproved) {
                return;
            }

            setRealProject({ ...realProject });

            const resp = await PutAction(`/api/task/change/status/${info.id}`, info);
            if (!resp.status) {
                errorToast(getError(resp));
            }
            await onSuccess();
            tasks.forEach((v) => {
                if (v.id === info.id) {
                    v.loading = false;
                }
            });
            setRealProject({ ...realProject });
        }
    }
    return (
        <div className="flex flex-wrap mt-3">

                <div className={"w-full lg:w-1/3 xl:w-1/3 px-2"}>
                <ActivityDetails
                    title={`TO DO`}
                    UpdateTask={PutAction}
                    onTaskChange={onTaskChange}
                    activity= {activity}
                    action={realProject?.status !== 'completed'}
                    onSuccess={()=>fecthActivity()}
                    deliverables={deliverables}
                    DeleteTask={customDeleteTask}
                    // isInitiator={canEdit}
                    isInitiator={isInitiator}
                    GetProject={GetProject}
                    deliverable={deliverable}
                    status={"to-do"}
                    project={realProject}
                    allTasks={realTasks}
                    assignees={assignees}
                    canEdit={true}
                    partners={partners}

                />
                </div>
                <div className={"w-full  lg:w-1/3 xl:w-1/3 px-2"}>
                <ActivityDetails
                    title={"IN PROGRESS"}
                    action={false}
                    UpdateTask={PutAction}
                    deliverables={deliverables}
                    DeleteTask={customDeleteTask}
                    isInitiator={isInitiator}
                    onSuccess={()=>fecthActivity()}
                    onTaskChange={onTaskChange}
                    activity= {activity}
                    GetProject={GetProject}
                    status={"in-progress"}
                    deliverable={deliverable}
                    project={realProject}
                    allTasks={realTasks}
                    assignees={assignees}
                    partners={partners}

                />
                </div>
                <div className={"w-full  lg:w-1/3 xl:w-1/3 px-2"}>

                <ActivityDetails
                    title={"UNDER REVIEW"}
                    UpdateTask={PutAction}
                    action={false}
                    activity= {activity}
                    DeleteTask={customDeleteTask}
                    onSuccess={()=>fecthActivity()}
                    onTaskChange={onTaskChange}
                    GetProject={GetProject}
                    deliverable={deliverable}
                    deliverables={deliverables}
                    isInitiator={isInitiator}
                    status={"to-verify"}
                    project={realProject}
                    allTasks={realTasks}
                    assignees={assignees}
                    partners={partners}
                />
                </div>
                <div className={"w-full  lg:w-1/3 xl:w-1/3 px-2"}>

                <ActivityDetails
                    status={"completed"}
                    action={false}
                    activity= {activity}
                    onTaskChange={onTaskChange}
                    GetProject={GetProject}
                    onSuccess={()=>fecthActivity()}
                    deliverable={deliverable}
                    deliverables={deliverables}
                    title={"COMPLETED"}
                    DeleteTask={customDeleteTask}
                    isInitiator={isInitiator}
                    project={realProject}
                    allTasks={realTasks}
                    UpdateTask={PutAction}
                    assignees={assignees}
                    partners={partners}

                />
                </div>
                <div className={"w-full  lg:w-1/3 xl:w-1/3 px-2"}>

                <ActivityDetails
                    status={"overdue"}
                    action={false}
                    activity= {activity}
                    onTaskChange={onTaskChange}
                    GetProject={GetProject}
                    onSuccess={()=>fecthActivity()}
                    deliverable={deliverable}
                    title={"OVERDUE"}
                    DeleteTask={customDeleteTask}
                    isInitiator={isInitiator}
                    project={realProject}
                    allTasks={realTasks}
                    UpdateTask={PutAction}
                    assignees={assignees}
                    partners={partners}

                />
                </div>

        </div>
    );
};

export default ProjectDndProvider;
